export default "__VITE_ASSET__GiYHwf_I__"